import {styled} from '@esgi/ui/theme';
import {Box} from '@esgi/ui/layout';
import {Label} from '@esgi/ui-kit/form-control';
import {Dropdown} from '@esgi/ui-kit/control';

export const DropdownContainerStyled = styled(Box, {
	width: '100%',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});

export const LabelStyled = styled(Label, {
	display: 'flex',
	fontWeight: 600,
	marginRight: '10px',

	'label': {
		marginBottom: '0px',
	},
});

export const DropdownStyled = styled(Box, {
	width: '200px',
});